import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://carli.explor.id/api'
});
// baseURL: "http://api32.ptpas.org"
// baseURL: "https://api.ptpas.org"

export default instance;
